import Repository from './repository'

export default {
    Indicadores () {
        return Repository.get('dashboard-indicador')
    }
}

